import React, { useEffect, useState } from "react";
import Banner2 from "../../components/Banner2";
import { Col, Container, Row } from "react-bootstrap";
import Contact from "../../components/Contact";
import { useDispatch, useSelector } from "react-redux";
import { getProducts } from "../../features/product";
import { useTranslation } from "react-i18next";
import SelectDropdown from "../../components/SelectDropdown";
import { getCompanyListWithClaimForm } from "../../features/company/companySlice";

const ClaimManagement = () => {
  const [requestData, setRequestData] = useState({});
  const [productData, setProductData] = useState([]);
  const [subProductData, setSubProductData] = useState([]);
  const [companyData, setCompanyData] = useState([]);
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const { companyList } = useSelector((state) => state.company);

  useEffect(() => {
    dispatch(getCompanyListWithClaimForm());
  }, [dispatch]);

  useEffect(() => {
    if (companyList && companyList.length) {
      // Step 1: Extract unique products
      const products = [
        ...new Map(
          companyList.map((item) => [
            item.product_id,
            { label: item.product_name, value: item.product_id },
          ])
        ).values(),
      ];

      // Step 2: Extract unique sub products (grouped by product_id)
      const subProducts = companyList.reduce((acc, item) => {
        if (!acc[item.product_id]) acc[item.product_id] = [];
        if (
          !acc[item.product_id].some((sp) => sp.value === item.sub_product_id)
        ) {
          acc[item.product_id].push({
            label: item.sub_product_name,
            value: item.sub_product_id,
          });
        }
        return acc;
      }, {});

      // Step 3: Extract companies (grouped by product_id + sub_product_id)
      const companies = companyList.reduce((acc, item) => {
        const key = `${item.product_id}_${item.sub_product_id}`;
        if (!acc[key]) acc[key] = [];
        acc[key].push({
          label: item.insurance_company_name,
          value: item.insurance_company_id,
          pdf: item.pdf,
        });
        return acc;
      }, {});
      setProductData(products);
      setSubProductData(subProducts);
      setCompanyData(companies);
    }
  }, [companyList]);

  const handleDownload = () => {
    if (requestData?.pdf_url) {
      const fileUrl = requestData?.pdf_url;
      const link = document.createElement("a");
      link.href = fileUrl;
      link.target = "_blank";
      link.setAttribute("download", "claim_form.pdf"); // Set the filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // Cleanup
    } else {
      console.error("No PDF URL found");
    }
  };

  return (
    <>
      <Banner2 classList="claim">
        <div className="bg-img">
          <img
            src={require("../../assets/images/banner-02.png")}
            alt="img"
            className="img-fluid"
          ></img>
        </div>
        <Container>
          <Row>
            <Col md={3}>
              <div className="policy-box">
                <div className="icon-image">
                  <img
                    src={require("../../assets/SVG/1-33.svg").default}
                    alt="icon"
                    className="img-fluid"
                  />
                </div>
                <p className="title">{t("claims_management.title")}</p>
              </div>
            </Col>
            <Col md={9}>
              <div className="policy-form">
                <p className="claim-text">
                  {t("claims_management.description")}
                </p>
                <div className="form-box d-flex align-items-center gap-3 ">
                  <SelectDropdown
                    name=""
                    placeholder={t("claims_management.type_of_insurance")}
                    options={productData}
                    handleOnChange={(name, value, index, label) => {
                      setRequestData({
                        ...requestData,
                        product_id: value,
                      });
                    }}
                    className="claim "
                  />
                  {subProductData &&
                    subProductData[requestData.product_id]?.length > 0 && (
                      <SelectDropdown
                        name=""
                        placeholder={t(
                          "claims_management.sub_type_of_insurance"
                        )}
                        options={subProductData[requestData.product_id]}
                        handleOnChange={(name, value, index, label) => {
                          setRequestData({
                            ...requestData,
                            sub_product_id: value,
                          });
                        }}
                        className="claim"
                      />
                    )}

                  {companyData &&
                    companyData[
                      `${requestData.product_id}_${requestData.sub_product_id}`
                    ]?.length > 0 && (
                      <SelectDropdown
                        name=""
                        placeholder={t("claims_management.insurance_company")}
                        options={
                          companyData[
                            `${requestData.product_id}_${requestData.sub_product_id}`
                          ]
                        }
                        handleOnChange={(name, value, index, label) => {
                          let pdf_url = companyData[
                            `${requestData.product_id}_${requestData.sub_product_id}`
                          ]?.find((item) => item.value === value)?.pdf;

                          setRequestData({
                            ...requestData,
                            pdf_url,
                          });
                        }}
                        className="claim"
                      />
                    )}

                  <div className="form-submitbtn">
                    <button
                      type="submit"
                      className="btn h-btn "
                      onClick={handleDownload}
                    >
                      {t("claims_management.download")}
                    </button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Banner2>
      <Contact />
    </>
  );
};

export default ClaimManagement;
